import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GATrackingEventType, GaTrackingEventLabel, GaTrackingEventCategory, GaTrackingEventName} from '../../constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { PRICE_TYPE_LOCATION_POPUP } from '~shared/modules/price-type-toggler/constants/interaction-location.constant';

export class GATrackingPriceTypeChangeEventModel implements GATrackingEvent {

  constructor(
    private priceType: PriceTypes,
    private location: string) {

  }

  getEventType(): GATrackingEventType {
    if (this.location === PRICE_TYPE_LOCATION_POPUP) {
      return GATrackingEventType.PriceTypePopup;
    } else {
      return GATrackingEventType.PriceTypeToggler;
    }
  }

  getEventLabel() {
    if (this.priceType === PriceTypes.b2b) {
      return GaTrackingEventLabel.PriceTypeChangeToB2B;
    } else {
      return GaTrackingEventLabel.PriceTypeChangeToB2C;
    }
  }

  getEventName() {
    if (this.location === PRICE_TYPE_LOCATION_POPUP) {
      return GaTrackingEventName.PricetypePopupAccepted;
    } else {
      return GaTrackingEventName.PriceToggler;
    }
  }


  getPayload(): GATrackingEventPayload {

    return {
      event: this.getEventName(),
      label: this.getEventLabel(),
      gtmCustom: {
        category: GaTrackingEventCategory.Interaction
      }
    };
  }
}
